'use client';
import { _ as _unsupportedIterableToArray } from './unsupportedIterableToArray-5baabfdc.esm.js';
import { b as _toPropertyKey, _ as _objectSpread2, a as _defineProperty } from './objectSpread2-c1340c1c.esm.js';
import React from 'react';
import { jsx } from 'react/jsx-runtime';

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

var ValExternalStore = /*#__PURE__*/function () {
  // uncertain whether this is the optimal way of returning

  function ValExternalStore() {
    var _this = this;
    _classCallCheck(this, ValExternalStore);
    _defineProperty(this, "subscribe", function (paths) {
      return function (listener) {
        var subscriberId = createSubscriberId(paths);
        if (!_this.listeners[subscriberId]) {
          _this.listeners[subscriberId] = [];
          _this.subscribers.set(subscriberId, {});
        }
        _this.listeners[subscriberId].push(listener);
        return function () {
          _this.listeners[subscriberId].splice(_this.listeners[subscriberId].indexOf(listener), 1);
        };
      };
    });
    _defineProperty(this, "getSnapshot", function (paths) {
      return function () {
        return _this.get(paths);
      };
    });
    _defineProperty(this, "getServerSnapshot", function (paths) {
      return function () {
        return _this.get(paths);
      };
    });
    _defineProperty(this, "get", function (paths) {
      var subscriberId = createSubscriberId(paths);
      return _this.subscribers.get(subscriberId);
    });
    this.subscribers = new Map();
    this.listeners = {};
  }
  return _createClass(ValExternalStore, [{
    key: "update",
    value: function update(path, source) {
      var subscriberIds = Array.from(this.subscribers.keys());
      for (var _i = 0, _subscriberIds = subscriberIds; _i < _subscriberIds.length; _i++) {
        var subscriberId = _subscriberIds[_i];
        var isSubscribedToModule = subscriberId.includes(path); // TODO: hash paths instead
        if (isSubscribedToModule) {
          this.subscribers.set(subscriberId, _objectSpread2(_objectSpread2({}, this.subscribers.get(subscriberId)), {}, _defineProperty({}, path, source)));
          this.emitChange(subscriberId);
        }
      }
    }
  }, {
    key: "emitChange",
    value: function emitChange(subscriberId) {
      var _iterator = _createForOfIteratorHelper(this.listeners[subscriberId]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var listener = _step.value;
          listener();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);
}();
function createSubscriberId(paths) {
  return paths.slice().sort().join("&");
}
var ValOverlayContext = /*#__PURE__*/React.createContext({
  store: undefined,
  draftMode: false
});
function ValOverlayProvider(_ref) {
  var store = _ref.store,
    draftMode = _ref.draftMode,
    children = _ref.children;
  return /*#__PURE__*/jsx(ValOverlayContext.Provider, {
    value: {
      store: store,
      draftMode: draftMode
    },
    children: children
  });
}
var useValOverlayContext = function useValOverlayContext() {
  return React.useContext(ValOverlayContext);
};

export { ValExternalStore, ValOverlayContext, ValOverlayProvider, useValOverlayContext };
